<template>
  <div class="tile">
    <div>
      <p class="text__bold text__center">Contact Info</p>
      <p class="flex__between tile--row">
        <span class="text__bold">Email:</span>
        <a :href="`mailto: ${primaryEmail}`">{{ primaryEmail }}</a>
      </p>
      <p class="flex__between tile--row">
        <span class="text__bold">Phone:</span>
        <span>{{ active.contact_info.phone ? active.contact_info.phone : "none" }}</span>
      </p>
      <p class="flex__between tile--row">
        <span class="text__bold">Mobile:</span>
        <span>{{ active.contact_info.mobile ? active.contact_info.mobile : "none" }}</span>
      </p>
      <p class="flex__between tile--row">
        <span class="text__bold">Fax:</span>
        <span>{{ active.contact_info.fax ? active.contact_info.fax : "none" }}</span>
      </p>
      <p class="flex__between tile--row align__start">
        <span class="text__bold">Address:</span>
        <span class="text__right">
          {{ active.address.street }}
          <br />
          {{ active.address.city}}, {{ active.address.state }}
          <br />
          {{ active.address.zip }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["active"],
  computed: {
    primaryEmail() {
      if (this.active.new_email && this.active.new_email.length > 0) {
        const emailObj = this.active.new_email
          .filter(email => {
            return email.primary;
          })
          .shift();
        return emailObj.email;
      } else {
        return this.active.email;
      }
    }
  }
};
</script>

<style scoped lang="scss">
</style>